<template>
  <div class="fit">
    <q-card class="fit">
      <q-card-section class="bg-primary text-white" style="flex: 0">
        <div class="row items-center">
          <div
            style="display: inline-block; font-family: 'Outfit', cursive"
            class="text-h6"
          >
            Scheduled Surveys
          </div>
          <q-btn
            class="q-ml-md"
            color="white"
            text-color="white"
            icon="mdi-plus"
            flat
            @click="newDialog = true"
          ></q-btn>
          <q-space />
          <q-input
            style="max-width: 70%"
            dark
            standout
            v-model="search"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </div>
      </q-card-section>

      <q-separator />
      <q-card-section class="q-pa-none" style="height: calc(100% - 72px)">
        <div class="row fit" v-if="scheduledSurveys">
          <div class="col-12 mt-0 pt-0 fit">
            <datatable
              :filter="search"
              :flat="true"
              :data="scheduledSurveys"
              :columns="columns"
              @rowSelected="handleSingleClick"
              @rowDoubleClick="handleDoubleClick"
            >
              <template slot="body-cell-location" slot-scope="data">
                <q-td :props="data.props">
                  {{ data.props.row.location }}
                  <q-tooltip>{{ data.props.row.location }}</q-tooltip>
                </q-td>
              </template>
              <template slot="body-cell-name" slot-scope="data">
                <q-td :props="data.props">
                  {{ data.props.row.name }}
                  <q-tooltip>{{ data.props.row.name }}</q-tooltip>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              New Scheduled Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-plus"
                label="Create"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="editForm"
            :surveyData="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
            @uploadDataLoading="(state) => (dataUploadLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.uploadData()"
                :loading="dataUploadLoading"
                text
                color="primary"
                class="float-left"
                icon="upload"
                label="Upload Data"
              >
              </q-btn>
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import agGrid from "@/components/agGrid";
import expandedToolbar from "@/components/expandedToolbar";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import placesAutocomplete from "@/components/googleMaps/placesAutocomplete.vue";
import datepicker from "@/components/wrappers/datepicker.vue";
import scheduledSurveyForm from "@/components/scheduledSurveys/scheduledSurveyForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    agGrid,
    expandedToolbar,
    datatable,
    placesAutocomplete,
    datepicker,
    scheduledSurveyForm,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentUserData",
      "selectedRowData",
      "aGGridActionMenu",
      "scheduledSurveys",
      "scheduledSurveysLoading",
    ]),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "archive",
        label: "",
        align: "left",
        field: "",
        sortable: true,
      },
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "date",
        label: "Date",
        align: "left",
        field: "date",
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),
        sortable: true,
      },
      {
        name: "location",
        label: "Location",
        align: "left",
        field: "location",
        sortable: true,
      },
      {
        name: "assignedUser",
        label: "Assigned User",
        align: "left",
        field: "usersName",
        sortable: true,
      },
      {
        name: "type",
        label: "Type",
        align: "left",
        field: "type",
        sortable: true,
      },
      {
        name: "depth",
        label: "Depth",
        align: "left",
        field: "startingDepth",
        sortable: true,
      },
      {
        name: "upperLimit",
        label: "Upper Limit",
        align: "left",
        field: "upperLimit",
        sortable: true,
      },
      {
        name: "lowerLimit",
        label: "Lower Limit",
        align: "left",
        field: "lowerLimit",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        field: "status",
        sortable: true,
      },
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    dataUploadLoading: false,
  }),
  beforeCreate() {
    this.$store.dispatch("loadScheduledSurveys");
  },
  mounted() {
    if (this.aGGridActionMenu == true) {
      this.$store.dispatch("setAGGridActionMenuState", {});
    }
  },
  methods: {
    handleSingleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
    handleDoubleClick(row) {
      // this.viewFormData = row;
      // this.viewDetailsDialog = true;
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
